const e=e=>t=>{e(t)};export{e as elementMutatorFactory};
//# sourceMappingURL=element-mutator.js.map